import {
  McpAuthorizeRequestSchema,
  type McpAuthorizeRequest,
} from '@laplace/contracts'

export interface McpAuthorizationSearch {
  request: McpAuthorizeRequest
  clientName: string
}

export function parseMcpAuthorizationSearch(
  href: string,
  origin: string,
): McpAuthorizationSearch | null {
  const url = new URL(href, origin)
  const raw = url.searchParams.get('mcp_consent')
  if (!raw) return null

  try {
    const normalized = raw.replace(/-/g, '+').replace(/_/g, '/')
    const binary = globalThis.atob(normalized)
    const bytes = Uint8Array.from(binary, (character) =>
      character.charCodeAt(0),
    )
    const parsed = McpAuthorizeRequestSchema.safeParse(
      JSON.parse(new TextDecoder().decode(bytes)),
    )
    if (!parsed.success) return null
    return {
      request: parsed.data,
      clientName: url.searchParams.get('mcp_client_name') || 'MCP client',
    }
  } catch {
    return null
  }
}
